/**
 * HTTP 请求封装
 * 使用 axios，统一 baseURL 与错误处理，便于后续接口复用
 */
import axios from 'axios'

const baseURL = process.env.VUE_APP_API_BASE_URL || ''

const request = axios.create({
  baseURL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 响应拦截：统一解析业务 code/message
request.interceptors.response.use(
  (response) => {
    const { data } = response
    return data
  },
  (error) => {
    if (error.response) {
      const { data, status } = error.response
      const message = (data && data.message) || `请求失败 (${status})`
      return Promise.reject(new Error(message))
    }
    if (error.code === 'ECONNABORTED') {
      return Promise.reject(new Error('请求超时，请稍后重试'))
    }
    return Promise.reject(new Error('网络异常，请稍后重试'))
  }
)

export default request
